import React from 'react'
import PostAuthor from './PostAuthor';
import TimeAgo from './TimeAgo';
import ReactionButtons from './ReactionButtons';
import { FaSpinner } from 'react-icons/fa'
import { useSelector } from 'react-redux';
import { selectItemById } from './postsSlice';

import { Link } from 'react-router-dom';

//let PostsExcerpt = ({ post }) => {
const PostsExcerpt = ({ postId }) => {
  const post = useSelector(state => selectItemById(state, postId))
  if (!post) {
    return null; // or return a placeholder if desired
  }
  return (
    <>
      <article id='presentation'> 
        <h3><FaSpinner /> {post.title}</h3>
        <small>
          <PostAuthor userId={post.userId}/>  
          <TimeAgo timestamp={post.date}/>
        </small>
        <p>
          {post.content && post.content.substring(0, 500)}... 
          <Link to={`/posts/${post.id}`}>See the post</Link>  {/* //changed from post */}
        </p>
        
        <ReactionButtons post={post}/>
        <br />
      </article>
      
    </>
  )
}

//PostsExcerpt = React.memo(PostsExcerpt);
export default PostsExcerpt